import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {CardDeck} from 'reactstrap';
import {withRouter} from "react-router-dom";
import reportsActionCreators from '../../store/reports/action-creators';
import LoadingOverlay from '../../../shared/components/LoadingOverlay';
import DashboardReports from './DashboardReports';
import DashboardTile from './DashboardTile';
import {
  reportsDueAcknowledgement,
  reportsWaitingAcknowledgement,
  reportsWaitingSubmit,
  reportsDueSubmit,
  reportsWaitingApprove, reportsDueApprove
} from '../../store/reports/selectors';
import trainingPhasesActionCreators from '../../store/training-phases/action-creators';
import Modal from '../../../shared/ui/Modal';
import OitProgressChart from './OitProgressChart';
import taskTrainingActionCreators from "../../store/task-training/action-creators";
import testsActionCreators from "../../store/tests/action-creators";
import {taskResponsesLateAck, taskResponsesWaitingAck} from "../../store/task-training/selectors";
import DashboardTasks from "./DashboardTasks";
import DashboardPendingTests from "./DashboardPendingTests";
import myTrainingProgramActionCreators from "../../store/my-training-program/action-creators";
import taskGroupsActions from '../../store/task-groups/action-creators/index';
import ReportViewSplit from "../reports/ReportViewSplit";
import ModalSplit from "../../../shared/ui/ModalSplit";
import CommonCreateReport from "../common/CommonCreateReport";

class OitDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isTaskResponseAckLoading: false,
      oitComment: '',
      lateOitComment: '',
      showCreateReportDialog: false,
    };
  }

  componentDidMount() {
    this.props.fetchReports('oit');
    this.props.fetchMyTaskResponses(this.props.userContext.userGuid);
    this.props.loadMyTrainingProgram();
    this.props.fetchTests();
    this.props.fetchTaskGroups();
  }

  updateComment(oitComment) {
    this.setState({
      oitComment
    })
  }

  updateLateComment(lateOitComment) {
    this.setState({
      lateOitComment
    })
  }

  get isLoading() {
    return this.props.isLoadingReports.includes('fetchReports');
  }

  get hasLateAckWarnings() {
    return (
      this.props.reportsDueAcknowledgement &&
      this.props.reportsDueAcknowledgement.length
    );
  }

  get hasLateSubmitWarnings() {
    return this.props.reportsDueSubmit && this.props.reportsDueSubmit.length;
  }

  openReport(report) {
    this.props.setIsViewingReport(report);
  }

  ackTaskResponse(taskResponse, commentField) {
    let comment = this.state[commentField];
    this.setState({
      isTaskResponseAckLoading: true
    });
    this.props.akcResponse(taskResponse.guid, comment, this.props.userContext.userGuid)
      .then(() => {

        this.setState({
          isTaskResponseAckLoading: false,
          [commentField]: ''
        });
      })
  }

  openTest(test) {
    this.props.history.push(`/tests/${test.id}`);
  }

  addReport(report) {
    if (report.status === 'scheduled') {
      this.props.addScheduledReport(report.guid, report.type);
    } else {
      this.props.editReport(report.guid);
    }
  }

  render() {
    return (
      <Fragment>
        <div className="app-content-header">
          <h4 className="title">Dashboard</h4>
          <p className="sub-title text-muted"><button onClick={() => this.setState({showCreateReportDialog: true})} className="button primary small">Add report</button> Officer in Training</p>
        </div>
        <div className="app-content dashboard">
          <LoadingOverlay isLoading={this.isLoading}>
            <CardDeck>
              <DashboardTile
                link="/my-completed-reports"
                icon="address-card"
                title="View Completed Observations"
                color="#333"
              />
              <DashboardTile
                link="/task-training"
                icon="tasks"
                title="View Tasks progress"
                color="#5d9de4"
              />
            </CardDeck>
            <div className="dashboard-reports-deck">
              <DashboardReports
                showOitName
                nextReportActive
                icon="list-alt"
                viewReportIcon="edit"
                title="MY UPCOMING REPORTS"
                addReportLabel="Complete new form"
                nextReportLabel="Next report for submission"
                reports={this.props.reportsWaitingSubmit}
                noReportsMessage="No reports pending submission"
                onViewReport={report => this.addReport(report)}
              />

              <DashboardReports
                showOitName
                nextReportActive
                icon="warning"
                viewReportIcon="edit"
                title="MY LATE REPORTS"
                nextReportLabel="Next report for submission"
                addReportLabel="Complete late form"
                reports={this.props.reportsDueSubmit}
                noReportsMessage="No reports pending submission"
                hasWarnings={this.hasLateSubmitWarnings}
                onViewReport={report => this.addReport(report)}
              />
            </div>

            <div className="dashboard-reports-deck">
              <DashboardReports
                icon="calendar-check-o"
                nextReportActive
                nextReportLabel="Next report for acknowledgement"
                viewReportIcon="thumbs-up"
                title="Observation Acknowledgement"
                reports={[...(this.props.reportsWaitingAcknowledgement || []), ...(this.props.reportsWaitingApprove || [])]}
                noReportsMessage="No reports waiting acknowledgement"
                onViewReport={report => this.openReport(report)}
              />
              <DashboardReports
                icon="warning"
                nextReportActive
                nextReportLabel="Next report for acknowledgement"
                viewReportIcon="thumbs-up"
                title="Late Observation Acknowledgement"
                reports={[...(this.props.reportsDueAcknowledgement || []), ...(this.props.reportsDueApprove || [])]}
                hasWarnings={this.hasLateAckWarnings}
                noReportsMessage="No late reports waiting acknowledgement"
                onViewReport={report => this.openReport(report)}
              />
            </div>
            <div className="dashboard-reports-deck">
              <DashboardTasks
                icon="tasks"
                taskResponses={this.props.taskResponsesWaitingAck}
                taskGroupsMap={this.props.taskGroupsMap}
                title="Task Acknowledgement"
                isLoading={this.state.isTaskResponseAckLoading}
                ackComment={this.state.oitComment}
                updateComment={this.updateComment.bind(this)}
                onAck={(taskResponse) => this.ackTaskResponse(taskResponse, 'oitComment')}
                userContext={this.props.userContext}
              />
              <DashboardTasks
                icon="warning"
                taskResponses={this.props.taskResponsesLateAck}
                taskGroupsMap={this.props.taskGroupsMap}
                title="Late Task Acknowledgement"
                isLoading={this.state.isTaskResponseAckLoading}
                ackComment={this.state.lateOitComment}
                updateComment={this.updateLateComment.bind(this)}
                onAck={(taskResponse) => this.ackTaskResponse(taskResponse, 'lateOitComment')}
                userContext={this.props.userContext}
              />
            </div>
            <div className="dashboard-reports-deck">
              <DashboardPendingTests
                icon="list-alt"
                tests={this.props.tests}
                title="Pending Tests"
                onOpenTest={(test) => this.openTest(test)}
              />
              <div className="dashboard-tasks card"></div>
            </div>
            {this.props.oitTraining
              ? <OitProgressChart hideTopAxis showMyProgram/>
              : <h3 className="text-center">Training not Started</h3>}
          </LoadingOverlay>
        </div>
        <ModalSplit
          isOpen={!!this.props.viewingReport}
          onClose={() => this.props.setIsViewingReport(null)}
          title={this.props.viewingReport && this.props.viewingReport.formName}
        >
          <ReportViewSplit report={this.props.viewingReport} />
        </ModalSplit>
        <Modal
          isOpen={this.state.showCreateReportDialog}
          onClose={() => this.setState({showCreateReportDialog: false})}
          title="Create Report"
          size="small"
        >
          {this.state.showCreateReportDialog && this.props.oitTraining && (
            <CommonCreateReport
              selfOnly
              oit={this.props.oitTraining}
              trainingPhases={this.props.myTrainingPhases}
              onFinish={() => this.setState({showCreateReportDialog: false})}
            />
          )}
        </Modal>
      </Fragment>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    userContext: state.common.userContext,
    isLoading: state.dashboard.isLoading,
    isLoadingReports: state.reports.isLoading,
    viewingReport: state.reports.viewingReport,
    oitTraining: state.myTrainingProgram.oit,
    myTrainingPhases: state.myTrainingProgram.trainingPhases,
    reportsWaitingAcknowledgement: reportsWaitingAcknowledgement(state),
    reportsWaitingApprove: reportsWaitingApprove(state),
    reportsDueApprove: reportsDueApprove(state),
    reportsDueAcknowledgement: reportsDueAcknowledgement(state),
    taskResponsesLateAck: taskResponsesLateAck(state),
    taskResponsesWaitingAck: taskResponsesWaitingAck(state),
    tests: state.tests.list,
    taskGroupsMap: state.taskGroups.taskGroupMap,
    reportsWaitingSubmit: reportsWaitingSubmit(state),
    reportsDueSubmit: reportsDueSubmit(state)
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchReports: (scope) => {
      return dispatch(reportsActionCreators.fetchReports(scope));
    },
    setIsViewingReport: (report) => {
      return dispatch(reportsActionCreators.setIsViewingReport(report));
    },
    viewReport: (reportGuid) => {
      return dispatch(trainingPhasesActionCreators.viewReport(reportGuid));
    },
    fetchMyTaskResponses: (oitGuid) => {
      return dispatch(taskTrainingActionCreators.fetchOitTaskResponses());
    },
    akcResponse: (taskResponseGuid, comment, oitGuid) => {
      return dispatch(taskTrainingActionCreators.ackResponse(taskResponseGuid, comment, oitGuid))
    },
    loadMyTrainingProgram: () => {
      return dispatch(myTrainingProgramActionCreators.loadMyTrainingProgram());
    },
    fetchTests() {
      return dispatch(testsActionCreators.fetchMyTests());
    },
    fetchTaskGroups: () => {
      return dispatch(taskGroupsActions.fetchTaskGroups());
    },
    addScheduledReport: (reportGuid, type) => {
      return dispatch(trainingPhasesActionCreators.addScheduledReport(reportGuid, type));
    },
    editReport: (reportGuid) => {
      return dispatch(trainingPhasesActionCreators.editReport(reportGuid));
    }
  };
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(OitDashboard));
